import { useCallback, useState, useSyncExternalStore } from 'react';

import {
  type NudgeStore,
  isDismissed,
  nudgeStoreForPlatform,
  rememberDismissal,
  storeUrl,
  subscribeDismissal,
} from '@/lib/nativeAppNudge';

export interface NativeAppNudge {
  store: NudgeStore | null;
  url: string | null;
  dismiss: () => void;
}

/**
 * Whether this page load should nudge toward a native app, and for which
 * store. The platform is fixed for the life of the page; the dismissal is
 * shared, so a "Not now" on any surface hides every mounted nudge.
 */
export function useNativeAppNudge(): NativeAppNudge {
  const [platformStore] = useState<NudgeStore | null>(nudgeStoreForPlatform);
  const dismissed = useSyncExternalStore(
    subscribeDismissal,
    isDismissed,
    () => true
  );
  const store = dismissed ? null : platformStore;
  const dismiss = useCallback(() => rememberDismissal(), []);

  return { store, url: store ? storeUrl(store) : null, dismiss };
}
